/**
 * Token utility functions
 * Handles JWT token decoding and parsing
 */

interface DecodedTokenPayload {
  [key: string]: any
}

/**
 * Decodes a JWT token and returns the payload
 * @param token - JWT token string
 * @returns Decoded token payload or null if invalid
 */
export const decodeJWTToken = (token: string): DecodedTokenPayload | null => {
  try {
    const tokenParts = token.split(".")
    
    if (tokenParts.length !== 3) {
      return null
    }

    const decodedPayload = JSON.parse(
      decodeURIComponent(
        escape(window.atob(tokenParts[1].replace(/-/g, "+").replace(/_/g, "/")))
      )
    )

    return decodedPayload
  } catch (error) {
    console.error("Error decoding token:", error)
    return null
  }
}

/**
 * Extracts token payload from auth response
 * Backend format: { success, data: { accessToken, refreshToken, user, expiresIn } }
 */
export const extractTokenPayload = (response: any): any => {
  const token = response?.data?.accessToken || response?.auth?.accessToken || response?.accessToken
  if (token) {
    const decodedPayload = decodeJWTToken(token)
    if (decodedPayload) {
      return { ...response, ...decodedPayload }
    }
  }
  return response
}

/** Extract user type from auth response (UserRoleType enum değeri) */
export const getUserTypeFromAuthResponse = (response: any): number | null => {
  const user =
    response?.data?.user ??
    response?.data?.data?.user ??
    response?.user
  const userType = user?.type
  if (userType != null && !isNaN(Number(userType))) {
    return parseInt(String(userType), 10)
  }
  return null
}

